import { combineReducers } from '@reduxjs/toolkit';
import { reducer as generalReducer } from '../slices/general';

export const rootReducer = combineReducers({
  general: generalReducer,
});
